// BLUECREW - API CONSTANTS
// =============================================================================

export const webV1Url = import.meta.env.VITE_WEB_V1_URL || "";
export const assetUrl = import.meta.env.VITE_ASSET_BASE_URL || "";
